/* tslint:disable */
/* This file was generated by @citrite/translate. Manual changes will be lost. */

export var languages = [{
  "key": "de",
  "content": {
    "alert_modal": {
      "error_title": "Fehler",
      "information_title": "Informationen",
      "success_title": "Erfolgreich",
      "warning_title": "Warnung"
    },
    "cancel": "Abbrechen",
    "clear_search": "Suche löschen",
    "close": "Schließen",
    "continue": "Weiter",
    "copy_link": "Link kopieren",
    "copy_success": "In Zwischenablage kopiert.",
    "custom_ellipsis": "Benutzerdefiniert...",
    "date": {
      "jump_back_month": "Einen Monat zurück",
      "jump_back_year": "Ein Jahr zurück",
      "jump_forward_month": "Einen Monat vorwärts",
      "jump_forward_year": "Ein Jahr vorwärts",
      "select_date": "Datum auswählen"
    },
    "generic_error_message": "Ein Fehler ist aufgetreten",
    "hide_password": "Kennwort ausblenden",
    "messageDialog": {
      "doNotShowThisAgain": "Nicht mehr anzeigen",
      "ok": "OK"
    },
    "no": "Nein",
    "percent": "{{percent}} %",
    "show_password": "Kennwort anzeigen",
    "svg": {
      "AirIcon": "AIR-Datei",
      "AlertIcon": "Fehlersymbol",
      "ApprovalsFileIcon": "Genehmigungsdatei",
      "AudioIcon": "Audiodatei",
      "CodeFileIcon": "Codedatei",
      "CwFormIcon": "Formularvorlage",
      "CwTemplateIcon": "Workflowvorlage",
      "CwWorkflowIcon": "Workflowinstanz",
      "DcmIcon": "DCM-Datei",
      "DwgIcon": "DWG-Datei",
      "EmailIcon": "E-Mail-Datei",
      "Empty404Icon": "Datei nicht gefunden (Bild)",
      "EmptyAppsIcon": "Anwendung (Bild)",
      "EmptyCommentsIcon": "Kommentare (Bild)",
      "EmptyCompleteIcon": "Alle Elemente abgeschlossen (Bild)",
      "EmptyComputerIcon": "Computer (Bild)",
      "EmptyDashboardIcon": "Dashboard (Bild)",
      "EmptyDocumentIcon": "Dokument (Bild)",
      "EmptyErrorIcon": "Fehler (Bild)",
      "EmptyFavoritesIcon": "Favoritenordner (Bild)",
      "EmptyFolderIcon": "Ordner (Bild)",
      "EmptyFormsIcon": "Formular (Bild)",
      "EmptyListIcon": "Liste (Bild)",
      "EmptyMedicalImageIcon": "Bildgebung (Bild)",
      "EmptyNotificationsIcon": "Benachrichtigung (Bild)",
      "EmptyPeopleIcon": "Menschen (Bild)",
      "EmptySearchIcon": "Suche (Bild)",
      "EmptyServerIcon": "Server (Bild)",
      "EmptySignatureIcon": "Signiertes Dokument (Bild)",
      "EmptyTemplatesIcon": "Vorlage (Bild)",
      "EmptyTrashIcon": "Papierkorb (Bild)",
      "EmptyUpload0Icon": "Keine hochgeladenen Dateien (Bild)",
      "EmptyUploadIcon": "Upload (Bild)",
      "EmptyVideosIcon": "Video (Bild)",
      "EmptyWorkflowIcon": "Workflow (Bild)",
      "EpsIcon": "EPS-Datei",
      "ExcelIcon": "Excel-Datei",
      "FileboxIcon": "Dateibox",
      "FlashIcon": "Flash-Datei",
      "FolderIcon": "Ordner",
      "IllustratorIcon": "Illustrator-Datei",
      "ImagesIcon": "Bilddatei",
      "IndesignIcon": "InDesign-Datei",
      "InfoIcon": "Informationssymbol",
      "KeynoteIcon": "Keynote-Datei",
      "MdbIcon": "Microsoft Access-Datei",
      "MedicalIcon": "Medizinische Bilddatei",
      "MppIcon": "Microsoft Project-Datei",
      "NoteIcon": "Notizdatei",
      "NumbersIcon": "Numbers-Datei",
      "NwcIcon": "NWC-Datei",
      "NwdIcon": "NWD-Datei",
      "NwfIcon": "NWF-Datei",
      "OneIcon": "One-Datei",
      "PagesIcon": "Pages-Datei",
      "PdfIcon": "PDF-Datei",
      "PhotoshopIcon": "Photoshop-Datei",
      "PowerpointIcon": "PowerPoint-Datei",
      "PubIcon": "Publisher-Datei",
      "QbbIcon": "QuickBooks-Backupdatei",
      "QbwIcon": "QuickBooks-Datei",
      "RequestListIcon": "PBC-Listendatei",
      "RvtIcon": "Revit-Datei",
      "SketchIcon": "Sketch-Datei",
      "SuccessIcon": "Erfolgssymbol",
      "TextIcon": "Textdatei",
      "UnknownIcon": "Unbekannte Datei",
      "UrlIcon": "Webadresse",
      "VideoIcon": "Videodatei",
      "VsdIcon": "Visio-Datei",
      "WarningIcon": "Warnsymbol",
      "WordIcon": "Microsoft Word-Datei",
      "ZipIcon": "ZIP-Datei"
    },
    "table": {
      "select_all": "Alle Elemente auswählen"
    },
    "time": {
      "am": "AM",
      "am_or_pm": "AM oder PM",
      "hour": "Stunde",
      "minute": "Minute",
      "pm": "PM",
      "select_a_time": "Zeit auswählen"
    },
    "typeahead": {
      "clear": "Löschen",
      "no_results": "Keine Ergebnisse gefunden",
      "remove_item": "Remove",
      "start_typing": "Beginnen Sie mit der Eingabe..."
    },
    "validation": {
      "enter_greater_value": "Geben Sie einen Wert größer oder gleich {{value}} ein.",
      "enter_required_value": "Dieses Feld ist erforderlich.",
      "enter_smaller_value": "Geben Sie einen Wert kleiner oder gleich {{value}} ein.",
      "enter_valid_digit": "Geben Sie eine gültige Ziffer ein",
      "exceed_max_chars": "Zeichenlimit erreicht, die Nachricht wurde möglicherweise abgeschnitten",
      "formattedNumberField": {
        "cannotBeBetweenError": "Die Zahl darf nicht zwischen {{min}} und {{max}} liegen",
        "cannotBeEqualError": "Die Zahl darf nicht gleich {{number}} sein",
        "mustBeBetweenError": "Die Zahl muss zwischen {{min}} und {{max}} liegen",
        "mustBeGreaterEqualError": "Die Zahl muss größer oder gleich {{number}} sein",
        "mustBeGreaterError": "Die Zahl muss größer als {{number}} sein",
        "mustBeLessEqualError": "Die Zahl muss kleiner oder gleich {{number}} sein",
        "mustBeLessError": "Die Zahl muss kleiner als {{number}} sein",
        "notNumber": "Dem Bindestrich muss eine Ziffer folgen.",
        "overCharLimitError": "Geben Sie einen Wert innerhalb des Zeichenlimits ein."
      },
      "invalid_email": "Ungültige E-Mail"
    },
    "yes": "Ja"
  }
}, {
  "key": "en",
  "content": {
    "alert_modal": {
      "error_title": "Error",
      "information_title": "Information",
      "success_title": "Success",
      "warning_title": "Warning"
    },
    "cancel": "Cancel",
    "clear_search": "Clear search",
    "close": "Close",
    "continue": "Continue",
    "copy_link": "Copy Link",
    "copy_success": "Copied to Clipboard!",
    "custom_ellipsis": "Custom...",
    "date": {
      "jump_back_month": "Jump back one month",
      "jump_back_year": "Jump back one year",
      "jump_forward_month": "Jump forward one month",
      "jump_forward_year": "Jump forward one year",
      "select_date": "Select date"
    },
    "generic_error_message": "An error occurred",
    "hide_password": "Hide Password",
    "messageDialog": {
      "doNotShowThisAgain": "Do not show this again",
      "ok": "OK"
    },
    "no": "No",
    "percent": "{{percent}}%",
    "show_password": "Show Password",
    "svg": {
      "AirIcon": "Air file",
      "AlertIcon": "Error icon",
      "ApprovalsFileIcon": "Approvals file",
      "AudioIcon": "Audio file",
      "CodeFileIcon": "Code file",
      "CwFormIcon": "Form template",
      "CwTemplateIcon": "Workflow template",
      "CwWorkflowIcon": "Workflow instance",
      "DcmIcon": "DCM file",
      "DwgIcon": "DWG file",
      "EmailIcon": "Email file",
      "Empty404Icon": "File not found illustration",
      "EmptyAppsIcon": "Application illustration",
      "EmptyCommentsIcon": "Comments illustration",
      "EmptyCompleteIcon": "All items completed illustration",
      "EmptyComputerIcon": "Computer illustration",
      "EmptyDashboardIcon": "Dashboard illustration",
      "EmptyDocumentIcon": "Document illustration",
      "EmptyErrorIcon": "Error illustration",
      "EmptyFavoritesIcon": "Favorite folder illustration",
      "EmptyFolderIcon": "Folder illustration",
      "EmptyFormsIcon": "Form illustration",
      "EmptyListIcon": "List document illustration",
      "EmptyMedicalImageIcon": "Medical image illustration",
      "EmptyNotificationsIcon": "Notification illustration",
      "EmptyPeopleIcon": "People illustration",
      "EmptySearchIcon": "Search illustration",
      "EmptyServerIcon": "Server illustration",
      "EmptySignatureIcon": "Signed document illustration",
      "EmptyTemplatesIcon": "Template illustration",
      "EmptyTrashIcon": "Trash can illustration",
      "EmptyUpload0Icon": "No files uploaded illustration",
      "EmptyUploadIcon": "Upload illustration",
      "EmptyVideosIcon": "Video illustration",
      "EmptyWorkflowIcon": "Workflow illustration",
      "EpsIcon": "EPS file",
      "ExcelIcon": "Excel file",
      "FileboxIcon": "Filebox",
      "FlashIcon": "Flash file",
      "FolderIcon": "Folder",
      "IllustratorIcon": "Illustrator file",
      "ImagesIcon": "Image file",
      "IndesignIcon": "Indesign file",
      "InfoIcon": "Information icon",
      "KeynoteIcon": "Keynote file",
      "MdbIcon": "Microsoft Access file",
      "MedicalIcon": "Medical Image file",
      "MppIcon": "Microsoft Project file",
      "NoteIcon": "Note file",
      "NumbersIcon": "Numbers file",
      "NwcIcon": "NWC file",
      "NwdIcon": "NWD file",
      "NwfIcon": "NWF file",
      "OneIcon": "One file",
      "PagesIcon": "Pages file",
      "PdfIcon": "PDF file",
      "PhotoshopIcon": "Photoshop file",
      "PowerpointIcon": "Powerpoint file",
      "PubIcon": "Publisher file",
      "QbbIcon": "QuickBooks Backup file",
      "QbwIcon": "QuickBooks file",
      "RequestListIcon": "PBC List file",
      "RvtIcon": "Revit file",
      "SketchIcon": "Sketch file",
      "SuccessIcon": "Success icon",
      "TextIcon": "Text file",
      "UnknownIcon": "Unknown file",
      "UrlIcon": "Web address",
      "VideoIcon": "Video file",
      "VsdIcon": "Visio file",
      "WarningIcon": "Warning icon",
      "WordIcon": "Microsoft Word file",
      "ZipIcon": "Zip file"
    },
    "table": {
      "select_all": "Select all items"
    },
    "time": {
      "am": "AM",
      "am_or_pm": "AM or PM",
      "hour": "Hour",
      "minute": "Minute",
      "pm": "PM",
      "select_a_time": "Select Time"
    },
    "typeahead": {
      "clear": "Clear",
      "no_results": "No results found",
      "remove_item": "Remove",
      "start_typing": "Start typing..."
    },
    "validation": {
      "enter_greater_value": "Please enter a value greater than or equal to {{value}}.",
      "enter_required_value": "This field is required.",
      "enter_smaller_value": "Please enter a value less than or equal to {{value}}.",
      "enter_valid_digit": "Please enter a digit",
      "exceed_max_chars": "Message has reached character limit, some of the desired message may have been cut off",
      "formattedNumberField": {
        "cannotBeBetweenError": "The number cannot be between {{min}}-{{max}}",
        "cannotBeEqualError": "The number cannot be equal to {{number}}",
        "mustBeBetweenError": "The number must be between {{min}}-{{max}}",
        "mustBeGreaterEqualError": "The number must be greater than or equal to {{number}}",
        "mustBeGreaterError": "The number must be greater than {{number}}",
        "mustBeLessEqualError": "The number must be less than or equal to {{number}}",
        "mustBeLessError": "The number must be less than {{number}}",
        "notNumber": "Hyphen should followed by a number.",
        "overCharLimitError": "Please enter a value under the character limit."
      },
      "invalid_email": "Invalid Email"
    },
    "yes": "Yes"
  }
}, {
  "key": "es",
  "content": {
    "alert_modal": {
      "error_title": "Error",
      "information_title": "Información",
      "success_title": "Correcto",
      "warning_title": "Advertencia"
    },
    "cancel": "Cancelar",
    "clear_search": "Borrar búsqueda",
    "close": "Cerrar",
    "continue": "Continuar",
    "copy_link": "Copiar enlace",
    "copy_success": "¡Copiado al portapapeles!",
    "custom_ellipsis": "Personalizar...",
    "date": {
      "jump_back_month": "Retroceder un mes",
      "jump_back_year": "Retroceder un año",
      "jump_forward_month": "Avanzar un mes",
      "jump_forward_year": "Avanzar un año",
      "select_date": "Seleccionar fecha"
    },
    "generic_error_message": "Se ha producido un error",
    "hide_password": "Ocultar contraseña",
    "messageDialog": {
      "doNotShowThisAgain": "No volver a mostrar esto",
      "ok": "Aceptar"
    },
    "no": "No",
    "percent": "{{percent}}%",
    "show_password": "Mostrar contraseña",
    "svg": {
      "AirIcon": "Archivo AIR",
      "AlertIcon": "Icono de error",
      "ApprovalsFileIcon": "Archivo de aprobaciones",
      "AudioIcon": "Archivo de audio",
      "CodeFileIcon": "Archivo de código",
      "CwFormIcon": "Plantilla de formulario",
      "CwTemplateIcon": "Plantilla de flujo de trabajo",
      "CwWorkflowIcon": "Instancia de flujo de trabajo",
      "DcmIcon": "Archivo DCM",
      "DwgIcon": "Archivo DWG",
      "EmailIcon": "Archivo de correo electrónico",
      "Empty404Icon": "Ilustración de archivo no encontrado",
      "EmptyAppsIcon": "Ilustración de aplicación",
      "EmptyCommentsIcon": "Ilustración de comentarios",
      "EmptyCompleteIcon": "Ilustración de todos los elementos completados",
      "EmptyComputerIcon": "Ilustración de equipo",
      "EmptyDashboardIcon": "Ilustración de panel de mandos",
      "EmptyDocumentIcon": "Ilustración de documento",
      "EmptyErrorIcon": "Ilustración de error",
      "EmptyFavoritesIcon": "Ilustración de la carpeta Favoritos",
      "EmptyFolderIcon": "Ilustración de carpeta",
      "EmptyFormsIcon": "Ilustración de formulario",
      "EmptyListIcon": "Ilustración de lista de documentos",
      "EmptyMedicalImageIcon": "Ilustración de imagen médica",
      "EmptyNotificationsIcon": "Ilustración de notificación",
      "EmptyPeopleIcon": "Ilustración de personas",
      "EmptySearchIcon": "Ilustración de búsqueda",
      "EmptyServerIcon": "Ilustración de servidor",
      "EmptySignatureIcon": "Ilustración de documento firmado",
      "EmptyTemplatesIcon": "Ilustración de plantilla",
      "EmptyTrashIcon": "Ilustración de papelera",
      "EmptyUpload0Icon": "Ilustración de vista sin archivos cargados",
      "EmptyUploadIcon": "Ilustración de carga de archivos",
      "EmptyVideosIcon": "Ilustración de vídeo",
      "EmptyWorkflowIcon": "Ilustración de flujo de trabajo",
      "EpsIcon": "Archivo EPS",
      "ExcelIcon": "Archivo Excel",
      "FileboxIcon": "Caja de archivos",
      "FlashIcon": "Archivo Flash",
      "FolderIcon": "Carpeta",
      "IllustratorIcon": "Archivo Illustrator",
      "ImagesIcon": "Archivo de imagen",
      "IndesignIcon": "Archivo InDesign",
      "InfoIcon": "Icono de información",
      "KeynoteIcon": "Archivo Keynote",
      "MdbIcon": "Archivo Microsoft Access",
      "MedicalIcon": "Archivo de imagen médica",
      "MppIcon": "Archivo Microsoft Project",
      "NoteIcon": "Archivo de nota",
      "NumbersIcon": "Archivo de números",
      "NwcIcon": "Archivo NWC",
      "NwdIcon": "Archivo NWD",
      "NwfIcon": "Archivo NWF",
      "OneIcon": "Archivo One",
      "PagesIcon": "Archivo Pages",
      "PdfIcon": "Archivo PDF",
      "PhotoshopIcon": "Archivo Photoshop",
      "PowerpointIcon": "Archivo PowerPoint",
      "PubIcon": "Archivo Publisher",
      "QbbIcon": "Archivo de copia de seguridad QuickBooks",
      "QbwIcon": "Archivo QuickBooks",
      "RequestListIcon": "Archivo de lista PBC",
      "RvtIcon": "Archivo Revit",
      "SketchIcon": "Archivo Sketch",
      "SuccessIcon": "Icono de operación correcta",
      "TextIcon": "Archivo de texto",
      "UnknownIcon": "Archivo desconocido",
      "UrlIcon": "Dirección web",
      "VideoIcon": "Archivo de vídeo",
      "VsdIcon": "Archivo Visio",
      "WarningIcon": "Icono de advertencia",
      "WordIcon": "Archivo Microsoft Word",
      "ZipIcon": "Archivo zip"
    },
    "table": {
      "select_all": "Seleccionar todos los elementos"
    },
    "time": {
      "am": "AM",
      "am_or_pm": "AM o PM",
      "hour": "Hora",
      "minute": "Minuto",
      "pm": "PM",
      "select_a_time": "Seleccionar hora"
    },
    "typeahead": {
      "clear": "Borrar",
      "no_results": "No hay resultados",
      "remove_item": "Remove",
      "start_typing": "Comience a escribir..."
    },
    "validation": {
      "enter_greater_value": "Introduzca un valor mayor o igual a {{value}}.",
      "enter_required_value": "Este campo es obligatorio.",
      "enter_smaller_value": "Introduzca un valor menor o igual a {{value}}.",
      "enter_valid_digit": "Introduzca un dígito",
      "exceed_max_chars": "El mensaje ha alcanzado el límite de caracteres y es posible que se haya cortado parte del mensaje",
      "formattedNumberField": {
        "cannotBeBetweenError": "El número no puede estar entre {{min}} y {{max}}",
        "cannotBeEqualError": "El número no puede ser igual a {{number}}",
        "mustBeBetweenError": "El número debe estar entre {{min}} y {{max}}",
        "mustBeGreaterEqualError": "El número debe ser mayor o igual a {{number}}",
        "mustBeGreaterError": "El número debe ser mayor que {{number}}",
        "mustBeLessEqualError": "El número debe ser menor o igual a {{number}}",
        "mustBeLessError": "El número debe ser menor que {{number}}",
        "notNumber": "El guion debe ir seguido de un número.",
        "overCharLimitError": "Introduzca un valor por debajo del límite de caracteres."
      },
      "invalid_email": "Correo electrónico no válido"
    },
    "yes": "Sí"
  }
}, {
  "key": "fr",
  "content": {
    "alert_modal": {
      "error_title": "Erreur",
      "information_title": "Informations",
      "success_title": "Succès",
      "warning_title": "Avertissement"
    },
    "cancel": "Annuler",
    "clear_search": "Effacer la recherche",
    "close": "Fermer",
    "continue": "Continuer",
    "copy_link": "Copier le lien",
    "copy_success": "Copié sur le Presse-papiers !",
    "custom_ellipsis": "Personnaliser...",
    "date": {
      "jump_back_month": "Revenir un mois en arrière",
      "jump_back_year": "Revenir une année en arrière",
      "jump_forward_month": "Avancer d'un mois",
      "jump_forward_year": "Avancer d'un an",
      "select_date": "Sélectionner date"
    },
    "generic_error_message": "Une erreur s'est produite",
    "hide_password": "Masquer le mot de passe",
    "messageDialog": {
      "doNotShowThisAgain": "Ne plus afficher ce message",
      "ok": "OK"
    },
    "no": "Non",
    "percent": "{{percent}}%",
    "show_password": "Afficher le mot de passe",
    "svg": {
      "AirIcon": "Fichier Air",
      "AlertIcon": "Icône d'erreur",
      "ApprovalsFileIcon": "Fichier d'approbations",
      "AudioIcon": "Fichier audio",
      "CodeFileIcon": "Fichier de code",
      "CwFormIcon": "Modèle de formulaire",
      "CwTemplateIcon": "Modèle de workflow",
      "CwWorkflowIcon": "Instance de workflow",
      "DcmIcon": "Fichier DCM",
      "DwgIcon": "Fichier DWG",
      "EmailIcon": "Fichier e-mail",
      "Empty404Icon": "Illustration de fichier non trouvé",
      "EmptyAppsIcon": "Illustration d'application",
      "EmptyCommentsIcon": "Illustration de commentaires",
      "EmptyCompleteIcon": "Illustration de tous les éléments terminés",
      "EmptyComputerIcon": "Illustration d’ordinateur",
      "EmptyDashboardIcon": "Illustration de tableau de bord",
      "EmptyDocumentIcon": "Illustration de document",
      "EmptyErrorIcon": "Illustration d’erreur",
      "EmptyFavoritesIcon": "Illustration du dossier Favoris",
      "EmptyFolderIcon": "Illustration de dossier",
      "EmptyFormsIcon": "Illustration de formulaire",
      "EmptyListIcon": "Illustration de liste de documents",
      "EmptyMedicalImageIcon": "Illustration d'image médicale",
      "EmptyNotificationsIcon": "Illustration de notification",
      "EmptyPeopleIcon": "Illustration de personnes",
      "EmptySearchIcon": "Illustration de recherche",
      "EmptyServerIcon": "Illustration de serveur",
      "EmptySignatureIcon": "Illustration de document signé",
      "EmptyTemplatesIcon": "Illustration de modèle",
      "EmptyTrashIcon": "Illustration de poubelle",
      "EmptyUpload0Icon": "Illustration d'aucun fichier chargé",
      "EmptyUploadIcon": "Illustration de chargement",
      "EmptyVideosIcon": "Illustration de vidéo",
      "EmptyWorkflowIcon": "Illustration de workflow",
      "EpsIcon": "Fichier EPS",
      "ExcelIcon": "Fichier Excel",
      "FileboxIcon": "Zone de fichier",
      "FlashIcon": "Fichier Flash",
      "FolderIcon": "Dossier",
      "IllustratorIcon": "Fichier Illustrator",
      "ImagesIcon": "Fichier image",
      "IndesignIcon": "Fichier Indesign",
      "InfoIcon": "Icône d'information",
      "KeynoteIcon": "Fichier Keynote",
      "MdbIcon": "Fichier Microsoft Access",
      "MedicalIcon": "Fichier d'image médicale",
      "MppIcon": "Fichier Microsoft Project",
      "NoteIcon": "Fichier Note",
      "NumbersIcon": "Fichier Numbers",
      "NwcIcon": "Fichier NWC",
      "NwdIcon": "Fichier NWD",
      "NwfIcon": "Fichier NWF",
      "OneIcon": "Fichier One",
      "PagesIcon": "Fichier Pages",
      "PdfIcon": "Fichier PDF",
      "PhotoshopIcon": "Fichier Photoshop",
      "PowerpointIcon": "Fichier Powerpoint",
      "PubIcon": "Fichier Publisher",
      "QbbIcon": "Fichier de sauvegarde QuickBooks",
      "QbwIcon": "Fichier QuickBooks",
      "RequestListIcon": "Fichier de liste PBC",
      "RvtIcon": "Fichier Revit",
      "SketchIcon": "Fichier Sketch",
      "SuccessIcon": "Icône de succès",
      "TextIcon": "Fichier texte",
      "UnknownIcon": "Fichier inconnu",
      "UrlIcon": "Adresse Web",
      "VideoIcon": "Fichier vidéo",
      "VsdIcon": "Fichier Visio",
      "WarningIcon": "Icône d'avertissement",
      "WordIcon": "Fichier Microsoft Word",
      "ZipIcon": "Fichier zip"
    },
    "table": {
      "select_all": "Sélectionner tous les éléments"
    },
    "time": {
      "am": "AM",
      "am_or_pm": "AM ou PM",
      "hour": "Heure",
      "minute": "Minute",
      "pm": "PM",
      "select_a_time": "Sélectionner heure"
    },
    "typeahead": {
      "clear": "Effacer",
      "no_results": "Aucun résultat trouvé",
      "remove_item": "Remove",
      "start_typing": "Commencez à taper..."
    },
    "validation": {
      "enter_greater_value": "Entrez une valeur supérieure ou égale à {{value}}.",
      "enter_required_value": "Ce champ est obligatoire.",
      "enter_smaller_value": "Entrez une valeur inférieure ou égale à {{value}}.",
      "enter_valid_digit": "Veuillez entrer un chiffre",
      "exceed_max_chars": "Le message a atteint la limite de caractères. Il est possible qu'il soit tronqué",
      "formattedNumberField": {
        "cannotBeBetweenError": "Le nombre ne peut pas être compris entre {{min}} et {{max}}",
        "cannotBeEqualError": "Le nombre ne peut pas être égal à {{number}}",
        "mustBeBetweenError": "Le nombre doit être compris entre {{min}} et {{max}}",
        "mustBeGreaterEqualError": "Le nombre doit être supérieur ou égal à {{number}}",
        "mustBeGreaterError": "Le nombre doit être supérieur à {{number}}",
        "mustBeLessEqualError": "Le nombre doit être inférieur ou égal à {{number}}",
        "mustBeLessError": "Le nombre doit être inférieur à {{number}}",
        "notNumber": "Le trait d'union doit être suivi d'un nombre.",
        "overCharLimitError": "Veuillez entrer une valeur inférieure à la limite de caractères."
      },
      "invalid_email": "E-mail non valide"
    },
    "yes": "Oui"
  }
}, {
  "key": "it",
  "content": {
    "alert_modal": {
      "error_title": "Error",
      "information_title": "Information",
      "success_title": "Success",
      "warning_title": "Warning"
    },
    "cancel": "Annulla",
    "clear_search": "Cancella ricerca",
    "close": "Chiudi",
    "continue": "Continua",
    "copy_link": "Copia collegamento",
    "copy_success": "Copiato negli Appunti",
    "custom_ellipsis": "Personalizzato...",
    "date": {
      "jump_back_month": "Torna indietro di un mese",
      "jump_back_year": "Torna indietro di un anno",
      "jump_forward_month": "Salta in avanti di un mese",
      "jump_forward_year": "Salta in avanti di un anno",
      "select_date": "Seleziona data"
    },
    "generic_error_message": "An error occurred",
    "hide_password": "Nascondi password",
    "messageDialog": {
      "doNotShowThisAgain": "Non visualizzare più questo messaggio",
      "ok": "OK"
    },
    "no": "No",
    "percent": "{{percent}}%",
    "show_password": "Mostra password",
    "svg": {
      "AirIcon": "File Air",
      "AlertIcon": "Icona di errore",
      "ApprovalsFileIcon": "File approvazioni",
      "AudioIcon": "File audio",
      "CodeFileIcon": "File codice",
      "CwFormIcon": "Modello di modulo",
      "CwTemplateIcon": "Modello di flusso di lavoro",
      "CwWorkflowIcon": "Istanza di flusso di lavoro",
      "DcmIcon": "File DCM",
      "DwgIcon": "File DWG",
      "EmailIcon": "File e-mail",
      "Empty404Icon": "Illustrazione file non trovato",
      "EmptyAppsIcon": "Illustrazione applicazione",
      "EmptyCommentsIcon": "Illustrazione commenti",
      "EmptyCompleteIcon": "Illustrazione tutti gli elementi completati",
      "EmptyComputerIcon": "Illustrazione computer",
      "EmptyDashboardIcon": "Illustrazione dashboard",
      "EmptyDocumentIcon": "Illustrazione documento",
      "EmptyErrorIcon": "Illustrazione errore",
      "EmptyFavoritesIcon": "Illustrazione cartella preferita",
      "EmptyFolderIcon": "Illustrazione cartella",
      "EmptyFormsIcon": "Illustrazione modulo",
      "EmptyListIcon": "Illustrazione elenco documenti",
      "EmptyMedicalImageIcon": "Illustrazione immagine medica",
      "EmptyNotificationsIcon": "Illustrazione notifica",
      "EmptyPeopleIcon": "Illustrazione persone",
      "EmptySearchIcon": "Illustrazione ricerca",
      "EmptyServerIcon": "Illustrazione server",
      "EmptySignatureIcon": "Illustrazione documento firmato",
      "EmptyTemplatesIcon": "Illustrazione modello",
      "EmptyTrashIcon": "Illustrazione cestino",
      "EmptyUpload0Icon": "Illustrazione nessun file caricato",
      "EmptyUploadIcon": "Illustrazione caricamento",
      "EmptyVideosIcon": "Illustrazione video",
      "EmptyWorkflowIcon": "Illustrazione flusso di lavoro",
      "EpsIcon": "File EPS",
      "ExcelIcon": "File Excel",
      "FileboxIcon": "Cartella condivisione file",
      "FlashIcon": "File Flash",
      "FolderIcon": "Cartella",
      "IllustratorIcon": "File Illustrator",
      "ImagesIcon": "File immagine",
      "IndesignIcon": "File InDesign",
      "InfoIcon": "Icona Informazioni",
      "KeynoteIcon": "File Keynote",
      "MdbIcon": "File Microsoft Access",
      "MedicalIcon": "File immagine medica",
      "MppIcon": "File Microsoft Project",
      "NoteIcon": "File nota",
      "NumbersIcon": "File Numbers",
      "NwcIcon": "File NWC",
      "NwdIcon": "File NWD",
      "NwfIcon": "File NWF",
      "OneIcon": "File One",
      "PagesIcon": "File Pages",
      "PdfIcon": "File PDF",
      "PhotoshopIcon": "File Photoshop",
      "PowerpointIcon": "File PowerPoint",
      "PubIcon": "File Publisher",
      "QbbIcon": "File di backup QuickBooks",
      "QbwIcon": "File QuickBooks",
      "RequestListIcon": "File di elenco PBC",
      "RvtIcon": "File Revit",
      "SketchIcon": "File Sketch",
      "SuccessIcon": "Icona di operazione riuscita",
      "TextIcon": "File di testo",
      "UnknownIcon": "File sconosciuto",
      "UrlIcon": "Indirizzo Web",
      "VideoIcon": "File video",
      "VsdIcon": "File Visio",
      "WarningIcon": "Icona di avviso",
      "WordIcon": "File Microsoft Word",
      "ZipIcon": "File ZIP"
    },
    "table": {
      "select_all": "Seleziona tutti gli elementi"
    },
    "time": {
      "am": "AM",
      "am_or_pm": "AM o PM",
      "hour": "Ora",
      "minute": "Minuto",
      "pm": "PM",
      "select_a_time": "Selezionare l'ora"
    },
    "typeahead": {
      "clear": "Cancella",
      "no_results": "Nessun risultato trovato",
      "remove_item": "Remove",
      "start_typing": "Iniziare a digitare..."
    },
    "validation": {
      "enter_greater_value": "Immettere un valore pari o superiore a {{value}}.",
      "enter_required_value": "Questo campo è obbligatorio.",
      "enter_smaller_value": "Immettere un valore pari o inferiore a {{value}}.",
      "enter_valid_digit": "Immettere una cifra",
      "exceed_max_chars": "Il messaggio ha raggiunto il limite di caratteri. È possibile che parte del messaggio desiderato sia stata tagliata",
      "formattedNumberField": {
        "cannotBeBetweenError": "Il numero non può essere compreso tra {{min}} e {{max}}",
        "cannotBeEqualError": "Il numero non può essere pari a {{number}}",
        "mustBeBetweenError": "Il numero deve essere compreso tra {{min}} e {{max}}",
        "mustBeGreaterEqualError": "Il numero deve essere pari o superiore a {{number}}",
        "mustBeGreaterError": "Il numero deve essere superiore a {{number}}",
        "mustBeLessEqualError": "Il numero deve essere pari o inferiore a {{number}}",
        "mustBeLessError": "Il numero deve essere inferiore a {{number}}",
        "notNumber": "Il trattino deve essere seguito da un numero.",
        "overCharLimitError": "Immettere un valore inferiore al limite di caratteri."
      },
      "invalid_email": "E-mail non valido"
    },
    "yes": "Sì"
  }
}, {
  "key": "ja",
  "content": {
    "alert_modal": {
      "error_title": "Error",
      "information_title": "Information",
      "success_title": "Success",
      "warning_title": "Warning"
    },
    "cancel": "キャンセル",
    "clear_search": "検索のクリア",
    "close": "閉じる",
    "continue": "続行",
    "copy_link": "リンクのコピー",
    "copy_success": "クリップボードにコピーしました",
    "custom_ellipsis": "カスタム...",
    "date": {
      "jump_back_month": "1 か月前に移動",
      "jump_back_year": "1 年前に移動",
      "jump_forward_month": "1 か月後に移動",
      "jump_forward_year": "1 年後に移動",
      "select_date": "日付の選択"
    },
    "generic_error_message": "An error occurred",
    "hide_password": "パスワードの非表示",
    "messageDialog": {
      "doNotShowThisAgain": "次回からこれを表示しない",
      "ok": "OK"
    },
    "no": "いいえ",
    "percent": "{{percent}}%",
    "show_password": "パスワードの表示",
    "svg": {
      "AirIcon": "Air ファイル",
      "AlertIcon": "エラー アイコン",
      "ApprovalsFileIcon": "承認ファイル",
      "AudioIcon": "オーディオ ファイル",
      "CodeFileIcon": "コード ファイル",
      "CwFormIcon": "フォーム テンプレート",
      "CwTemplateIcon": "ワークフロー テンプレート",
      "CwWorkflowIcon": "ワークフロー インスタンス",
      "DcmIcon": "DCM ファイル",
      "DwgIcon": "DWG ファイル",
      "EmailIcon": "メール ファイル",
      "Empty404Icon": "ファイルが見つかりませんのイラスト",
      "EmptyAppsIcon": "アプリケーションのイラスト",
      "EmptyCommentsIcon": "コメントのイラスト",
      "EmptyCompleteIcon": "すべてのアイテムが完了したイラスト",
      "EmptyComputerIcon": "コンピューターのイラスト",
      "EmptyDashboardIcon": "ダッシュボードのイラスト",
      "EmptyDocumentIcon": "ドキュメントのイラスト",
      "EmptyErrorIcon": "エラーのイラスト",
      "EmptyFavoritesIcon": "お気に入りのフォルダーのイラスト",
      "EmptyFolderIcon": "フォルダーのイラスト",
      "EmptyFormsIcon": "フォームのイラスト",
      "EmptyListIcon": "一覧ドキュメントのイラスト",
      "EmptyMedicalImageIcon": "医療用イメージングのイラスト",
      "EmptyNotificationsIcon": "通知のイラスト",
      "EmptyPeopleIcon": "人のイラスト",
      "EmptySearchIcon": "検索のイラスト",
      "EmptyServerIcon": "サーバーのイラスト",
      "EmptySignatureIcon": "署名済みドキュメントのイラスト",
      "EmptyTemplatesIcon": "テンプレートのイラスト",
      "EmptyTrashIcon": "ゴミ箱のイラスト",
      "EmptyUpload0Icon": "ファイルがアップロードされていませんのイラスト",
      "EmptyUploadIcon": "アップロードのイラスト",
      "EmptyVideosIcon": "ビデオのイラスト",
      "EmptyWorkflowIcon": "ワークフローのイラスト",
      "EpsIcon": "EPS ファイル",
      "ExcelIcon": "Excel ファイル",
      "FileboxIcon": "FileBox",
      "FlashIcon": "Flash ファイル",
      "FolderIcon": "フォルダー",
      "IllustratorIcon": "Illustrator ファイル",
      "ImagesIcon": "イメージ ファイル",
      "IndesignIcon": "Indesign ファイル",
      "InfoIcon": "情報アイコン",
      "KeynoteIcon": "Keynote ファイル",
      "MdbIcon": "Microsoft Access ファイル",
      "MedicalIcon": "医用画像ファイル",
      "MppIcon": "Microsoft Project ファイル",
      "NoteIcon": "Note ファイル",
      "NumbersIcon": "Numbers ファイル",
      "NwcIcon": "NWC ファイル",
      "NwdIcon": "NWD ファイル",
      "NwfIcon": "NWF ファイル",
      "OneIcon": "One ファイル",
      "PagesIcon": "Pages ファイル",
      "PdfIcon": "PDF ファイル",
      "PhotoshopIcon": "Photoshop ファイル",
      "PowerpointIcon": "Powerpoint ファイル",
      "PubIcon": "Publisher ファイル",
      "QbbIcon": "QuickBooks バックアップ ファイル",
      "QbwIcon": "QuickBooks ファイル",
      "RequestListIcon": "PBC 一覧ファイル",
      "RvtIcon": "Revit ファイル",
      "SketchIcon": "Sketch ファイル",
      "SuccessIcon": "成功アイコン",
      "TextIcon": "テキスト ファイル",
      "UnknownIcon": "不明なファイル",
      "UrlIcon": "Web アドレス",
      "VideoIcon": "ビデオ ファイル",
      "VsdIcon": "Visio ファイル",
      "WarningIcon": "警告アイコン",
      "WordIcon": "Microsoft Word ファイル",
      "ZipIcon": "Zip ファイル"
    },
    "table": {
      "select_all": "すべてのアイテムを選択"
    },
    "time": {
      "am": "午前",
      "am_or_pm": "午前/午後",
      "hour": "時",
      "minute": "分",
      "pm": "午後",
      "select_a_time": "時間の選択"
    },
    "typeahead": {
      "clear": "クリア",
      "no_results": "結果が見つかりません",
      "remove_item": "Remove",
      "start_typing": "入力を開始..."
    },
    "validation": {
      "enter_greater_value": "{{value}}以上の値を入力してください。",
      "enter_required_value": "このフィールドは必須です。",
      "enter_smaller_value": "{{value}}以下の値を入力してください。",
      "enter_valid_digit": "数字を入力してください",
      "exceed_max_chars": "メッセージが文字数の上限を超えています。メッセージの一部が表示されない可能性があります。",
      "formattedNumberField": {
        "cannotBeBetweenError": "数字を{{min}}～{{max}}の間で指定することはできません",
        "cannotBeEqualError": "{{number}}を指定することはできません",
        "mustBeBetweenError": "数字は{{min}}～{{max}}の間で指定してください",
        "mustBeGreaterEqualError": "数字は{{number}}以上にしてください",
        "mustBeGreaterError": "{{number}}より大きな数字を指定してください",
        "mustBeLessEqualError": "数字は{{number}}以下にしてください",
        "mustBeLessError": "{{number}}より小さな数字を指定してください",
        "notNumber": "数字の前はハイフンにする必要があります。",
        "overCharLimitError": "文字数制限に値を入力してください。"
      },
      "invalid_email": "無効なメール"
    },
    "yes": "はい"
  }
}, {
  "key": "ko",
  "content": {
    "alert_modal": {
      "error_title": "오류",
      "information_title": "정보",
      "success_title": "성공",
      "warning_title": "경고"
    },
    "cancel": "취소",
    "clear_search": "검색 지우기",
    "close": "닫기",
    "continue": "계속",
    "copy_link": "링크 복사",
    "copy_success": "클립보드에 복사했습니다.",
    "custom_ellipsis": "사용자 지정...",
    "date": {
      "jump_back_month": "한 달 뒤로 이동",
      "jump_back_year": "1년 뒤로 이동",
      "jump_forward_month": "한 달 앞으로 이동",
      "jump_forward_year": "1년 앞으로 이동",
      "select_date": "날짜 선택"
    },
    "generic_error_message": "오류가 발생함",
    "hide_password": "암호 숨기기",
    "messageDialog": {
      "doNotShowThisAgain": "이 메시지 다시 표시 안 함",
      "ok": "확인"
    },
    "no": "아니요",
    "percent": "{{percent}}%",
    "show_password": "암호 표시",
    "svg": {
      "AirIcon": "Air 파일",
      "AlertIcon": "오류 아이콘",
      "ApprovalsFileIcon": "승인 파일",
      "AudioIcon": "오디오 파일",
      "CodeFileIcon": "코드 파일",
      "CwFormIcon": "양식 템플릿",
      "CwTemplateIcon": "워크플로 템플릿",
      "CwWorkflowIcon": "워크플로 인스턴스",
      "DcmIcon": "DCM 파일",
      "DwgIcon": "DWG 파일",
      "EmailIcon": "전자 메일 파일",
      "Empty404Icon": "파일을 찾을 수 없음 일러스트레이션",
      "EmptyAppsIcon": "응용 프로그램 일러스트레이션",
      "EmptyCommentsIcon": "설명 일러스트레이션",
      "EmptyCompleteIcon": "모든 항목 완료됨 일러스트레이션",
      "EmptyComputerIcon": "컴퓨터 일러스트레이션",
      "EmptyDashboardIcon": "대시보드 일러스트레이션",
      "EmptyDocumentIcon": "문서 일러스트레이션",
      "EmptyErrorIcon": "오류 일러스트레이션",
      "EmptyFavoritesIcon": "즐겨찾기 폴더 일러스트레이션",
      "EmptyFolderIcon": "폴더 일러스트레이션",
      "EmptyFormsIcon": "양식 일러스트레이션",
      "EmptyListIcon": "문서 나열 일러스트레이션",
      "EmptyMedicalImageIcon": "의료 이미지 일러스트레이션",
      "EmptyNotificationsIcon": "알림 일러스트레이션",
      "EmptyPeopleIcon": "사람들 일러스트레이션",
      "EmptySearchIcon": "검색 일러스트레이션",
      "EmptyServerIcon": "서버 일러스트레이션",
      "EmptySignatureIcon": "서명된 문서 일러스트레이션",
      "EmptyTemplatesIcon": "템플릿 일러스트레이션",
      "EmptyTrashIcon": "휴지통 일러스트레이션",
      "EmptyUpload0Icon": "업로드된 파일 없음 일러스트레이션",
      "EmptyUploadIcon": "업로드 일러스트레이션",
      "EmptyVideosIcon": "비디오 일러스트레이션",
      "EmptyWorkflowIcon": "워크플로 일러스트레이션",
      "EpsIcon": "EPS 파일",
      "ExcelIcon": "Excel 파일",
      "FileboxIcon": "파일 보관함",
      "FlashIcon": "Flash 파일",
      "FolderIcon": "폴더",
      "IllustratorIcon": "Illustrator 파일",
      "ImagesIcon": "이미지 파일",
      "IndesignIcon": "Indesign 파일",
      "InfoIcon": "정보 아이콘",
      "KeynoteIcon": "Keynote 파일",
      "MdbIcon": "Microsoft Access 파일",
      "MedicalIcon": "의료 이미지 파일",
      "MppIcon": "Microsoft Project 파일",
      "NoteIcon": "메모 파일",
      "NumbersIcon": "숫자 파일",
      "NwcIcon": "NWC 파일",
      "NwdIcon": "NWD 파일",
      "NwfIcon": "NWF 파일",
      "OneIcon": "One 파일",
      "PagesIcon": "Pages 파일",
      "PdfIcon": "PDF 파일",
      "PhotoshopIcon": "Photoshop 파일",
      "PowerpointIcon": "Powerpoint 파일",
      "PubIcon": "Publisher 파일",
      "QbbIcon": "QuickBooks 백업 파일",
      "QbwIcon": "QuickBooks 파일",
      "RequestListIcon": "PBC 목록 파일",
      "RvtIcon": "Revit 파일",
      "SketchIcon": "Sketch 파일",
      "SuccessIcon": "성공 아이콘",
      "TextIcon": "텍스트 파일",
      "UnknownIcon": "알 수 없는 파일",
      "UrlIcon": "웹 주소",
      "VideoIcon": "비디오 파일",
      "VsdIcon": "Visio 파일",
      "WarningIcon": "경고 아이콘",
      "WordIcon": "Microsoft Word 파일",
      "ZipIcon": "Zip 파일"
    },
    "table": {
      "select_all": "모든 항목 선택"
    },
    "time": {
      "am": "오전",
      "am_or_pm": "오전 또는 오후",
      "hour": "시간",
      "minute": "분",
      "pm": "오후",
      "select_a_time": "시간 선택"
    },
    "typeahead": {
      "clear": "지우기",
      "no_results": "결과 없음",
      "remove_item": "Remove",
      "start_typing": "입력 시작..."
    },
    "validation": {
      "enter_greater_value": "{{value}}보다 크거나 같은 값을 입력하십시오.",
      "enter_required_value": "이 필드는 필수입니다.",
      "enter_smaller_value": "{{value}}보다 작거나 같은 값을 입력하십시오.",
      "enter_valid_digit": "숫자를 입력하십시오.",
      "exceed_max_chars": "메시지가 문자 제한에 도달했습니다. 원하는 메시지의 일부가 잘릴 수 있습니다.",
      "formattedNumberField": {
        "cannotBeBetweenError": "숫자는 {{min}}-{{max}} 사이일 수 없습니다.",
        "cannotBeEqualError": "숫자는 {{number}}일 수 없습니다.",
        "mustBeBetweenError": "숫자는 {{min}}-{{max}} 사이여야 합니다.",
        "mustBeGreaterEqualError": "숫자는 {{number}}보다 크거나 같아야 합니다.",
        "mustBeGreaterError": "숫자는 {{number}}보다 커야 합니다.",
        "mustBeLessEqualError": "숫자는 {{number}}보다 작거나 같아야 합니다.",
        "mustBeLessError": "숫자는 {{number}}보다 작아야 합니다.",
        "notNumber": "하이픈 뒤에 숫자가 와야 합니다.",
        "overCharLimitError": "문자 제한보다 짧게 값을 입력하십시오."
      },
      "invalid_email": "잘못된 전자 메일"
    },
    "yes": "예"
  }
}, {
  "key": "nl",
  "content": {
    "alert_modal": {
      "error_title": "Fout",
      "information_title": "Gegevens",
      "success_title": "Gelukt",
      "warning_title": "Waarschuwing"
    },
    "cancel": "Annuleren",
    "clear_search": "Zoekopdracht wissen",
    "close": "Sluiten",
    "continue": "Doorgaan",
    "copy_link": "Koppeling kopiëren",
    "copy_success": "Naar klembord gekopieerd",
    "custom_ellipsis": "Aangepast...",
    "date": {
      "jump_back_month": "Eén maand terug",
      "jump_back_year": "Eén jaar terug",
      "jump_forward_month": "Eén maand vooruit",
      "jump_forward_year": "Eén jaar vooruit",
      "select_date": "Datum selecteren"
    },
    "generic_error_message": "Er is een fout opgetreden",
    "hide_password": "Wachtwoord verborgen",
    "messageDialog": {
      "doNotShowThisAgain": "Niet opnieuw weergeven",
      "ok": "OK"
    },
    "no": "Nee",
    "percent": "{{percent}}%",
    "show_password": "Wachtwoord weergeven",
    "svg": {
      "AirIcon": "AIR-bestand",
      "AlertIcon": "Foutpictogram",
      "ApprovalsFileIcon": "Goedkeuringsbestand",
      "AudioIcon": "Audiobestand",
      "CodeFileIcon": "Codebestand",
      "CwFormIcon": "Formuliersjabloon",
      "CwTemplateIcon": "Werkstroomsjabloon",
      "CwWorkflowIcon": "Werkstroominstantie",
      "DcmIcon": "DCM-bestand",
      "DwgIcon": "DWG-bestand",
      "EmailIcon": "E-mailbestand",
      "Empty404Icon": "Bestand niet gevonden (afbeelding)",
      "EmptyAppsIcon": "Toepassing (afbeelding)",
      "EmptyCommentsIcon": "Opmerkingen (afbeelding)",
      "EmptyCompleteIcon": "Alle items voltooid (afbeelding)",
      "EmptyComputerIcon": "Computer (afbeelding)",
      "EmptyDashboardIcon": "Dashboard (afbeelding)",
      "EmptyDocumentIcon": "Document (afbeelding)",
      "EmptyErrorIcon": "Fout (afbeelding)",
      "EmptyFavoritesIcon": "Favoriete map (afbeelding)",
      "EmptyFolderIcon": "Map (afbeelding)",
      "EmptyFormsIcon": "Formulier (afbeelding)",
      "EmptyListIcon": "Lijst met documenten (afbeelding)",
      "EmptyMedicalImageIcon": "Medisch beeld (afbeelding)",
      "EmptyNotificationsIcon": "Melding (afbeelding)",
      "EmptyPeopleIcon": "Personen (afbeelding)",
      "EmptySearchIcon": "Zoeken (afbeelding)",
      "EmptyServerIcon": "Server (afbeelding)",
      "EmptySignatureIcon": "Ondertekend document (afbeelding)",
      "EmptyTemplatesIcon": "Sjabloon (afbeelding)",
      "EmptyTrashIcon": "Prullenbak (afbeelding)",
      "EmptyUpload0Icon": "Geen bestanden geüpload (afbeelding)",
      "EmptyUploadIcon": "Upload (afbeelding)",
      "EmptyVideosIcon": "Video (afbeelding)",
      "EmptyWorkflowIcon": "Werkstroom (afbeelding)",
      "EpsIcon": "EPS-bestand",
      "ExcelIcon": "Excel-bestand",
      "FileboxIcon": "Bestandsvak",
      "FlashIcon": "Flash-bestand",
      "FolderIcon": "Map",
      "IllustratorIcon": "Illustrator-bestand",
      "ImagesIcon": "Afbeeldingsbestand",
      "IndesignIcon": "InDesign-bestand",
      "InfoIcon": "Informatiepictogram",
      "KeynoteIcon": "Keynote-bestand",
      "MdbIcon": "Microsoft Access-bestand",
      "MedicalIcon": "Medisch beeldbestand",
      "MppIcon": "Microsoft Project-bestand",
      "NoteIcon": "Notitiebestand",
      "NumbersIcon": "Numbers-bestand",
      "NwcIcon": "NWC-bestand",
      "NwdIcon": "NWD-bestand",
      "NwfIcon": "NWF-bestand",
      "OneIcon": "One-bestand",
      "PagesIcon": "Pages-bestand",
      "PdfIcon": "PDF-bestand",
      "PhotoshopIcon": "Photoshop-bestand",
      "PowerpointIcon": "PowerPoint-bestand",
      "PubIcon": "Publisher-bestand",
      "QbbIcon": "QuickBooks-backupbestand",
      "QbwIcon": "QuickBooks-bestand",
      "RequestListIcon": "PBC-lijstbestand",
      "RvtIcon": "Revit-bestand",
      "SketchIcon": "Sketch-bestand",
      "SuccessIcon": "Succespictogram",
      "TextIcon": "Tekstbestand",
      "UnknownIcon": "Onbekend bestand",
      "UrlIcon": "Webadres",
      "VideoIcon": "Videobestand",
      "VsdIcon": "Visio-bestand",
      "WarningIcon": "Waarschuwingspictogram",
      "WordIcon": "Microsoft Word-bestand",
      "ZipIcon": "ZIP-bestand"
    },
    "table": {
      "select_all": "Alle items selecteren"
    },
    "time": {
      "am": "AM",
      "am_or_pm": "AM of PM",
      "hour": "Uur",
      "minute": "Minuut",
      "pm": "PM",
      "select_a_time": "Tijd selecteren"
    },
    "typeahead": {
      "clear": "Wissen",
      "no_results": "Geen resultaten gevonden",
      "remove_item": "Remove",
      "start_typing": "Begin met typen..."
    },
    "validation": {
      "enter_greater_value": "Geef een waarde op die groter dan of gelijk is aan {{value}}.",
      "enter_required_value": "Dit veld is verplicht.",
      "enter_smaller_value": "Geef een waarde op die kleiner dan of gelijk is aan {{value}}.",
      "enter_valid_digit": "Voer een cijfer in",
      "exceed_max_chars": "Het bericht heeft de tekenlimiet bereikt; een deel van het bericht is mogelijk afgekapt",
      "formattedNumberField": {
        "cannotBeBetweenError": "Het getal mag niet tussen {{min}} en {{max}} zijn",
        "cannotBeEqualError": "Het getal mag niet gelijk zijn aan {{number}}",
        "mustBeBetweenError": "Het getal moet tussen {{min}} en {{max}} zijn",
        "mustBeGreaterEqualError": "Het getal moet groter zijn dan of gelijk zijn aan {{number}}",
        "mustBeGreaterError": "Het getal moet groter zijn dan {{number}}",
        "mustBeLessEqualError": "Het getal moet kleiner zijn dan of gelijk zijn aan {{number}}",
        "mustBeLessError": "Het getal moet kleiner zijn dan {{number}}",
        "notNumber": "Het afbreekstreepje moet gevolgd worden door een cijfer.",
        "overCharLimitError": "Voer een waarde in onder de tekenlimiet."
      },
      "invalid_email": "Ongeldige e-mail"
    },
    "yes": "Ja"
  }
}, {
  "key": "pt-BR",
  "content": {
    "alert_modal": {
      "error_title": "Erro",
      "information_title": "Informações",
      "success_title": "Sucesso",
      "warning_title": "Aviso"
    },
    "cancel": "Cancelar",
    "clear_search": "Limpar busca",
    "close": "Fechar",
    "continue": "Continuar",
    "copy_link": "Copiar link",
    "copy_success": "Copiado para a área de transferência!",
    "custom_ellipsis": "Personalizado...",
    "date": {
      "jump_back_month": "Voltar um mês",
      "jump_back_year": "Voltar um ano",
      "jump_forward_month": "Avançar um mês",
      "jump_forward_year": "Avançar um ano",
      "select_date": "Selecionar data"
    },
    "generic_error_message": "Ocorreu um erro",
    "hide_password": "Ocultar senha",
    "messageDialog": {
      "doNotShowThisAgain": "Não mostrar novamente",
      "ok": "OK"
    },
    "no": "Não",
    "percent": "{{percent}}%",
    "show_password": "Exibir a senha",
    "svg": {
      "AirIcon": "Arquivo Air",
      "AlertIcon": "Ícone de erro",
      "ApprovalsFileIcon": "Arquivo de aprovações",
      "AudioIcon": "Arquivo de áudio",
      "CodeFileIcon": "Arquivo de código",
      "CwFormIcon": "Modelo de formulário",
      "CwTemplateIcon": "Modelo de fluxo de trabalho",
      "CwWorkflowIcon": "Instância de fluxo de trabalho",
      "DcmIcon": "Arquivo DCM",
      "DwgIcon": "Arquivo DGW",
      "EmailIcon": "Arquivo de email",
      "Empty404Icon": "Ilustração de arquivo não encontrado",
      "EmptyAppsIcon": "Ilustração de aplicativo",
      "EmptyCommentsIcon": "Ilustrações de comentário",
      "EmptyCompleteIcon": "Ilustração de todos os itens concluídos",
      "EmptyComputerIcon": "Ilustração de computador",
      "EmptyDashboardIcon": "Ilustração de painel",
      "EmptyDocumentIcon": "Ilustração de documento",
      "EmptyErrorIcon": "Ilustração de erro",
      "EmptyFavoritesIcon": "Ilustração de pasta favorita",
      "EmptyFolderIcon": "Ilustração de pasta",
      "EmptyFormsIcon": "Ilustração de formulário",
      "EmptyListIcon": "Ilustração de lista de documentos",
      "EmptyMedicalImageIcon": "Ilustração de imagens médicas",
      "EmptyNotificationsIcon": "Ilustração de notificação",
      "EmptyPeopleIcon": "Ilustração de pessoas",
      "EmptySearchIcon": "Ilustração de busca",
      "EmptyServerIcon": "Ilustração de servidor",
      "EmptySignatureIcon": "Ilustração de documento assinado",
      "EmptyTemplatesIcon": "Ilustração de modelo",
      "EmptyTrashIcon": "Ilustração de lixeira",
      "EmptyUpload0Icon": "Ilustração de nenhum arquivo carregado",
      "EmptyUploadIcon": "Ilustração de upload",
      "EmptyVideosIcon": "Ilustração de vídeo",
      "EmptyWorkflowIcon": "Ilustração de fluxo de trabalho",
      "EpsIcon": "Arquivo EPS",
      "ExcelIcon": "Arquivo Excel",
      "FileboxIcon": "Caixa de arquivos",
      "FlashIcon": "Arquivo Flash",
      "FolderIcon": "Pasta",
      "IllustratorIcon": "Arquivo do Illustrator",
      "ImagesIcon": "Arquivo de imagem",
      "IndesignIcon": "Arquivo do InDesign",
      "InfoIcon": "Ícone de informação",
      "KeynoteIcon": "Arquivo do Keynote",
      "MdbIcon": "Arquivo do Microsoft Access",
      "MedicalIcon": "Arquivo de imagem médica",
      "MppIcon": "Arquivo do Microsoft Project",
      "NoteIcon": "Arquivo de nota",
      "NumbersIcon": "Arquivo de números",
      "NwcIcon": "Arquivo NWC",
      "NwdIcon": "Arquivo NWD",
      "NwfIcon": "Arquivo NWF",
      "OneIcon": "Arquivo do One",
      "PagesIcon": "Arquivo do Pages",
      "PdfIcon": "Arquivo PDF",
      "PhotoshopIcon": "Arquivo do Photoshop",
      "PowerpointIcon": "Arquivo do Powerpoint",
      "PubIcon": "Arquivo do Publisher",
      "QbbIcon": "Arquivo de backup do QuickBooks",
      "QbwIcon": "Arquivo do QuickBooks",
      "RequestListIcon": "Arquivo de lista PBC",
      "RvtIcon": "Arquivo do Revit",
      "SketchIcon": "Arquivo do Sketch",
      "SuccessIcon": "Ícone de sucesso",
      "TextIcon": "Arquivo de texto",
      "UnknownIcon": "Arquivo desconhecido",
      "UrlIcon": "Endereço da Web",
      "VideoIcon": "Arquivo de vídeo",
      "VsdIcon": "Arquivo do Visio",
      "WarningIcon": "Ícone de advertência",
      "WordIcon": "Arquivo do Microsoft Word",
      "ZipIcon": "Arquivo zip"
    },
    "table": {
      "select_all": "Selecionar todos os itens"
    },
    "time": {
      "am": "AM",
      "am_or_pm": "AM ou PM",
      "hour": "Hora",
      "minute": "Minuto",
      "pm": "PM",
      "select_a_time": "Selecione horário"
    },
    "typeahead": {
      "clear": "Apagar",
      "no_results": "Nenhum resultado encontrado",
      "remove_item": "Remove",
      "start_typing": "Comece a digitar..."
    },
    "validation": {
      "enter_greater_value": "Digite um valor maior ou igual a {{value}}.",
      "enter_required_value": "Este campo é obrigatório.",
      "enter_smaller_value": "Digite um valor menor ou igual a {{value}}.",
      "enter_valid_digit": "Forneça um dígito",
      "exceed_max_chars": "A mensagem atingiu o limite de caracteres, é possível que esteja incompleta",
      "formattedNumberField": {
        "cannotBeBetweenError": "O número não pode estar entre {{min}}-{{max}}",
        "cannotBeEqualError": "O número não pode ser igual a {{number}}",
        "mustBeBetweenError": "O número deve de estar entre {{min}}-{{max}}",
        "mustBeGreaterEqualError": "O número deve ser maior ou igual a {{number}}",
        "mustBeGreaterError": "O número deve ser maior que {{number}}",
        "mustBeLessEqualError": "O número deve ser menor ou igual a {{number}}",
        "mustBeLessError": "O número deve ser menor que {{number}}",
        "notNumber": "O hífen deve ser seguido de um número.",
        "overCharLimitError": "Digite um valor abaixo do limite de caracteres."
      },
      "invalid_email": "Email inválido"
    },
    "yes": "Sim"
  }
}, {
  "key": "ru",
  "content": {
    "alert_modal": {
      "error_title": "Ошибка",
      "information_title": "Сведения",
      "success_title": "Успешно",
      "warning_title": "Предупреждение"
    },
    "cancel": "Отмена",
    "clear_search": "Очистить поиск",
    "close": "Закрыть",
    "continue": "Продолжить",
    "copy_link": "Копировать ссылку",
    "copy_success": "Скопировано в буфер обмена.",
    "custom_ellipsis": "Настройка...",
    "date": {
      "jump_back_month": "Перейти на один месяц назад",
      "jump_back_year": "Перейти на один год назад",
      "jump_forward_month": "Перейти на один месяц вперед",
      "jump_forward_year": "Перейти на один год вперед",
      "select_date": "Выберите дату"
    },
    "generic_error_message": "Произошла ошибка",
    "hide_password": "Скрыть пароль",
    "messageDialog": {
      "doNotShowThisAgain": "Больше не показывать",
      "ok": "ОК"
    },
    "no": "Нет",
    "percent": "{{percent}} %",
    "show_password": "Показать пароль",
    "svg": {
      "AirIcon": "Файл Air",
      "AlertIcon": "Значок ошибки",
      "ApprovalsFileIcon": "Файл утверждений",
      "AudioIcon": "Аудиофайл",
      "CodeFileIcon": "Файл кодов",
      "CwFormIcon": "Шаблон формы",
      "CwTemplateIcon": "Шаблон рабочего процесса",
      "CwWorkflowIcon": "Экземпляр рабочего процесса",
      "DcmIcon": "Файл DCM",
      "DwgIcon": "Файл DWG",
      "EmailIcon": "Файл электронной почты",
      "Empty404Icon": "Иллюстрация того, что файл не найден",
      "EmptyAppsIcon": "Иллюстрация приложения",
      "EmptyCommentsIcon": "Иллюстрация комментариев",
      "EmptyCompleteIcon": "Иллюстрация того, что все элементы обработаны",
      "EmptyComputerIcon": "Иллюстрация компьютера",
      "EmptyDashboardIcon": "Иллюстрация панели мониторинга",
      "EmptyDocumentIcon": "Иллюстрация документа",
      "EmptyErrorIcon": "Иллюстрация ошибки",
      "EmptyFavoritesIcon": "Иллюстрация папки избранного",
      "EmptyFolderIcon": "Иллюстрация папки",
      "EmptyFormsIcon": "Иллюстрация формы",
      "EmptyListIcon": "Иллюстрация списка документов",
      "EmptyMedicalImageIcon": "Иллюстрация медицинского снимка",
      "EmptyNotificationsIcon": "Иллюстрация уведомления",
      "EmptyPeopleIcon": "Иллюстрация пользователей",
      "EmptySearchIcon": "Иллюстрация поиска",
      "EmptyServerIcon": "Иллюстрация сервера",
      "EmptySignatureIcon": "Иллюстрация подписанного документа",
      "EmptyTemplatesIcon": "Иллюстрация шаблона",
      "EmptyTrashIcon": "Иллюстрация корзины",
      "EmptyUpload0Icon": "Иллюстрация того, что нет отправленных файлов",
      "EmptyUploadIcon": "Иллюстрация отправки",
      "EmptyVideosIcon": "Иллюстрация видео",
      "EmptyWorkflowIcon": "Иллюстрация рабочего процесса",
      "EpsIcon": "Файл EPS",
      "ExcelIcon": "Файл Excel",
      "FileboxIcon": "FileBox",
      "FlashIcon": "Flash-файл",
      "FolderIcon": "Папка",
      "IllustratorIcon": "Файл Illustrator",
      "ImagesIcon": "Файл образа",
      "IndesignIcon": "Файл InDesign",
      "InfoIcon": "Значок информации",
      "KeynoteIcon": "Файл Keynote",
      "MdbIcon": "Файл Microsoft Access",
      "MedicalIcon": "Файл с медицинскими снимками",
      "MppIcon": "Файл Microsoft Project",
      "NoteIcon": "Файл Note",
      "NumbersIcon": "Файл Numbers",
      "NwcIcon": "Файл NWC",
      "NwdIcon": "Файл NWD",
      "NwfIcon": "Файл NWF",
      "OneIcon": "Файл One",
      "PagesIcon": "Файл Pages",
      "PdfIcon": "PDF-файл",
      "PhotoshopIcon": "Файл Photoshop",
      "PowerpointIcon": "Файл PowerPoint",
      "PubIcon": "Файл Publisher",
      "QbbIcon": "Файл резервной копии QuickBooks",
      "QbwIcon": "Файл QuickBooks",
      "RequestListIcon": "Файл списка PBC",
      "RvtIcon": "Файл Revit",
      "SketchIcon": "Файл Sketch",
      "SuccessIcon": "Значок успеха",
      "TextIcon": "Текстовый файл",
      "UnknownIcon": "Неизвестный файл",
      "UrlIcon": "Веб-адрес",
      "VideoIcon": "Видеофайл",
      "VsdIcon": "Файл Visio",
      "WarningIcon": "Значок предупреждения",
      "WordIcon": "Файл Microsoft Word",
      "ZipIcon": "ZIP-файл"
    },
    "table": {
      "select_all": "Выбрать все элементы"
    },
    "time": {
      "am": "до полудня",
      "am_or_pm": "До или после полудня",
      "hour": "Час",
      "minute": "Минута",
      "pm": "после полудня",
      "select_a_time": "Выберите время"
    },
    "typeahead": {
      "clear": "Очистить",
      "no_results": "Результаты не найдены",
      "remove_item": "Remove",
      "start_typing": "Начать ввод с клавиатуры..."
    },
    "validation": {
      "enter_greater_value": "Введите значение больше или равное {{value}}.",
      "enter_required_value": "Это обязательное поле.",
      "enter_smaller_value": "Введите значение меньше или равное {{value}}.",
      "enter_valid_digit": "Введите цифру",
      "exceed_max_chars": "В сообщении достигнуто максимальное количество символов. Некоторый текст сообщения может быть обрезан",
      "formattedNumberField": {
        "cannotBeBetweenError": "Число не может находиться в интервале между {{min}} и {{max}}",
        "cannotBeEqualError": "Число не может равняться {{number}}",
        "mustBeBetweenError": "Число должно находиться в интервале между {{min}} и {{max}}",
        "mustBeGreaterEqualError": "Число должно быть больше или равно {{number}}",
        "mustBeGreaterError": "Число должно быть больше {{number}}",
        "mustBeLessEqualError": "Число должно быть меньше или равно {{number}}",
        "mustBeLessError": "Число должно быть меньше {{number}}",
        "notNumber": "После дефиса должно следовать число.",
        "overCharLimitError": "Введите значение меньше максимального количество символов."
      },
      "invalid_email": "Недопустимый адрес электронной почты"
    },
    "yes": "Да"
  }
}, {
  "key": "zh-CN",
  "content": {
    "alert_modal": {
      "error_title": "错误",
      "information_title": "信息",
      "success_title": "成功",
      "warning_title": "警告"
    },
    "cancel": "取消",
    "clear_search": "清除搜索",
    "close": "关闭",
    "continue": "继续",
    "copy_link": "复制链接",
    "copy_success": "已复制到剪贴板!",
    "custom_ellipsis": "自定义...",
    "date": {
      "jump_back_month": "向后跳一个月",
      "jump_back_year": "向后跳一年",
      "jump_forward_month": "向前跳一个月",
      "jump_forward_year": "向前跳一年",
      "select_date": "选择日期"
    },
    "generic_error_message": "出现错误",
    "hide_password": "隐藏密码",
    "messageDialog": {
      "doNotShowThisAgain": "不再显示此消息",
      "ok": "确定"
    },
    "no": "否",
    "percent": "{{percent}}%",
    "show_password": "显示密码",
    "svg": {
      "AirIcon": "AIR 文件",
      "AlertIcon": "错误图标",
      "ApprovalsFileIcon": "审批文件",
      "AudioIcon": "音频文件",
      "CodeFileIcon": "代码文件",
      "CwFormIcon": "表单模板",
      "CwTemplateIcon": "工作流模板",
      "CwWorkflowIcon": "工作流实例",
      "DcmIcon": "DCM 文件",
      "DwgIcon": "DWG 文件",
      "EmailIcon": "电子邮件文件",
      "Empty404Icon": "“找不到文件”插图",
      "EmptyAppsIcon": "“应用程序”插图",
      "EmptyCommentsIcon": "“意见建议”插图",
      "EmptyCompleteIcon": "“所有项目已完成”插图",
      "EmptyComputerIcon": "“计算机”插图",
      "EmptyDashboardIcon": "“控制板”插图",
      "EmptyDocumentIcon": "“文档”插图",
      "EmptyErrorIcon": "“错误”插图",
      "EmptyFavoritesIcon": "“收藏夹”插图",
      "EmptyFolderIcon": "“文件夹”插图",
      "EmptyFormsIcon": "“表单”插图",
      "EmptyListIcon": "“列出文档”插图",
      "EmptyMedicalImageIcon": "“医学成像”插图",
      "EmptyNotificationsIcon": "“通知”插图",
      "EmptyPeopleIcon": "“用户”插图",
      "EmptySearchIcon": "“搜索”插图",
      "EmptyServerIcon": "“服务器”插图",
      "EmptySignatureIcon": "“已签名的文档”插图",
      "EmptyTemplatesIcon": "“模板”插图",
      "EmptyTrashIcon": "“垃圾桶”插图",
      "EmptyUpload0Icon": "“未上载任何文件”插图",
      "EmptyUploadIcon": "“上载”插图",
      "EmptyVideosIcon": "“视频”插图",
      "EmptyWorkflowIcon": "“工作流”插图",
      "EpsIcon": "EPS 文件",
      "ExcelIcon": "Excel 文件",
      "FileboxIcon": "文件盒",
      "FlashIcon": "Flash 文件",
      "FolderIcon": "文件夹",
      "IllustratorIcon": "Illustrator 文件",
      "ImagesIcon": "成像文件",
      "IndesignIcon": "Indesign 文件",
      "InfoIcon": "信息图标",
      "KeynoteIcon": "Keynote 文件",
      "MdbIcon": "Microsoft Access 文件",
      "MedicalIcon": "医学成像文件",
      "MppIcon": "Microsoft Project 文件",
      "NoteIcon": "Note 文件",
      "NumbersIcon": "Numbers 文件",
      "NwcIcon": "NWC 文件",
      "NwdIcon": "NWD 文件",
      "NwfIcon": "NWF 文件",
      "OneIcon": "One 文件",
      "PagesIcon": "Pages 文件",
      "PdfIcon": "PDF 文件",
      "PhotoshopIcon": "Photoshop 文件",
      "PowerpointIcon": "Powerpoint 文件",
      "PubIcon": "Publisher 文件",
      "QbbIcon": "QuickBooks 备份文件",
      "QbwIcon": "QuickBooks 文件",
      "RequestListIcon": "PBC 列表文件",
      "RvtIcon": "Revit 文件",
      "SketchIcon": "Sketch 文件",
      "SuccessIcon": "成功图标",
      "TextIcon": "文本文件",
      "UnknownIcon": "未知文件",
      "UrlIcon": "Web 地址",
      "VideoIcon": "视频文件",
      "VsdIcon": "Visio 文件",
      "WarningIcon": "警告图标",
      "WordIcon": "Microsoft Word 文件",
      "ZipIcon": "Zip 文件"
    },
    "table": {
      "select_all": "选择所有项目"
    },
    "time": {
      "am": "上午",
      "am_or_pm": "上午或下午",
      "hour": "小时",
      "minute": "分钟",
      "pm": "下午",
      "select_a_time": "选择时间"
    },
    "typeahead": {
      "clear": "清除",
      "no_results": "未找到结果",
      "remove_item": "Remove",
      "start_typing": "开始键入..."
    },
    "validation": {
      "enter_greater_value": "请输入大于或等于 {{value}} 的值。",
      "enter_required_value": "此字段为必填字段。",
      "enter_smaller_value": "请输入小于或等于 {{value}} 的值。",
      "enter_valid_digit": "请输入数字",
      "exceed_max_chars": "消息已达到字符限制，所需的某些消息可能已被截断",
      "formattedNumberField": {
        "cannotBeBetweenError": "数字不能介于 {{min}}-{{max}} 之间",
        "cannotBeEqualError": "数字不能等于 {{number}}",
        "mustBeBetweenError": "数字必须介于 {{min}}-{{max}} 之间",
        "mustBeGreaterEqualError": "数字必须大于或等于 {{number}}",
        "mustBeGreaterError": "数字必须大于 {{number}}",
        "mustBeLessEqualError": "数字必须小于或等于 {{number}}",
        "mustBeLessError": "数字必须小于 {{number}}",
        "notNumber": "连字符应后跟一个数字。",
        "overCharLimitError": "请输入不超过字符限制的值。"
      },
      "invalid_email": "电子邮件无效"
    },
    "yes": "是"
  }
}];